import React, { FC, memo, ReactNode } from 'react';
import { Row } from 'react-table';
import FnBodyRows from '../FnBodyRows';

type TProps = {
  rows: any[];
  prepareRow: any;
  customExpandedRows: Record<string, boolean>;
  customExpandedKey: string;
  visibleColumns: any[];
  expandedRowOffset: number;
  renderRowSubComponent: (row: Row<any>) => ReactNode;
  renderGroupRowSubComponent: (row: Row<any>[]) => ReactNode;
};

const FnGroupRows: FC<TProps> = ({
  prepareRow,
  renderRowSubComponent,
  customExpandedRows,
  visibleColumns,
  expandedRowOffset,
  rows,
  customExpandedKey,
  renderGroupRowSubComponent
}) => {
  return (
    <React.Fragment>
      {rows.map((gropedRows, index) => {
        return (
          <React.Fragment key={index}>
            <tr key={`group-${index}`} className="fn-group-tr">
              <td colSpan={visibleColumns.length - expandedRowOffset} className="fn-group-td">
                {/*
                  Inside it, call our renderRowSubComponent function. In reality,
                  you could pass whatever you want as props to
                  a component like this, including the entire
                  table instance. But for this example, we'll just
                  pass the row
                */}
                {renderGroupRowSubComponent ? renderGroupRowSubComponent(gropedRows) : null}
              </td>
            </tr>
            <FnBodyRows
              prepareRow={prepareRow}
              renderRowSubComponent={renderRowSubComponent}
              customExpandedRows={customExpandedRows}
              expandedRowOffset={expandedRowOffset}
              visibleColumns={visibleColumns}
              rows={gropedRows}
              customExpandedKey={customExpandedKey}
            />
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default memo(FnGroupRows);
